import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild('myElement') myElement!: ElementRef; // Referenza all'elemento nel template
  @ViewChild('myElement2') myElement2!: ElementRef; // Referenza all'elemento nel template

  heroData = {
    title: 'Easycode: coding e didattica <br> digitale per la tua scuola',
    subtitle:
      'Easycode è un progetto di <span class="bold">educazione al digitale</span> che offre corsi di apprendimento tecnologici e di  <span class="bold">coding </span>rivolti a bambini e ragazzi tra i 6 e i 18 anni. L’<span class="bold">educazione digitale </span>favorisce lo sviluppo del <span class="bold">pensiero computazionale </span>attraverso i nostri corsi di programmazione e videogames con Scratch, AppInventor, Minecraft e tanto altro!',
    imgSrc: '../../../assets/img/FLOPPY.png',
    class: 'floppy',
  };
  slideSelected: number = 1;
  cardSelected: number = 1;
  private isProcessing = false;

  coursesList: any = [
    {
      id: 1,
      name: 'Scratch',
      tag: 'T/E/M',
      img: 'assets/img/corsi/scratch.png',
      text: 'Crea cartoni animati, animazioni e storie interattive, quiz e puzzle, ma anche dei semplici giochi arcade.',
      url: '/scratch',
    },

    {
      id: 2,
      name: 'App Inventor',
      tag: 'T/E/M',
      img: 'assets/img/corsi/appInventor.png',
      text: 'è utilizzato per realizzare applicazioni Android. Consente di programmare senza scrivere codice.',
      url: '/app-inventor',
    },
    {
      id: 3,
      name: 'Robotica Educativa',
      tag: 'T/E/M',
      img: 'assets/img/corsi/robotica.png',
      text: 'Tramite la programmazione e lo sviluppo di un robot, si imparano le basi della programmazione.',
      url: '/robotica-educativa',
    },
  ];

  infoList: any = [
    {
      id: 1,
      name: 'Schede didattiche',
      tag: 'T/E/M',
      img: 'assets/img/schede-didattiche.png',
      text: 'Cerchi schede pixel art facili? Scarica le nostre schede da colorare per la tua classe o i tuoi bambini. Su ogni scheda troverai curiosità sulle ultime tecnologie per i più piccoli.',
      url: '/scratch',
    },

    {
      id: 2,
      name: 'Il nostro blog',
      tag: 'T/E/M',
      img: 'assets/img/blog.png',
      text: 'Vuoi saperne di più sull’intelligenza artificiale, sui corsi di robotica, o su cosa si intende per pensiero computazionale?',
      url: '/app-inventor',
    },
    {
      id: 3,
      name: 'Giochi e attività di coding',
      tag: 'T/E/M',
      img: 'assets/img/giochi.png',
      text: 'Se sei alla ricerca di attività di coding unplugged per i più piccoli, dai un’occhiata alla nostra pagina dedicata: potrai scaricare gratuitamente tutte le schede che desideri.',
      url: '/robotica-educativa',
    },
  ];

  cardList: any = [
    {
      id: 1,
      name: 'Cooperazione',
      tag: 'T/E/M',
      class: 'balloon',
      img: 'assets/img/Icona_blu.svg',
      text: "Attraverso le nostre attività, i bambini sperimenteranno l'importanza del lavoro di gruppo. Comunicazione, ascolto attivo e risoluzione dei conflitti, saranno tutte competenze essenziali per il loro futuro.",
      url: '',
    },

    {
      id: 2,
      name: 'Problem Solving',
      tag: 'T/E/M',
      img: 'assets/img/icona verde.svg',
      class: 'balloon',
      text: "Gli studenti impareranno a risolvere problemi complessi attraverso la sperimentazione, l'analisi e la riflessione critica. Tramite il coding, bambini e ragazzi faranno i primi passi verso il pensiero computazionale.",
      url: '',
    },
    {
      id: 3,
      name: 'Prepararsi al futuro',
      tag: 'T/E/M',
      img: 'assets/img/icona verde.svg',
      text: 'Con i nostri corsi di coding, i ragazzi imparano a comprendere e utilizzare la tecnologia in modo critico e creativo. In questo modo, saranno pronti ad affrontare le sfide del futuro con fiducia e successo.',
      url: '',
      class: 'balloon',
    },
  ];


  constructor(private router: Router) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    const element = this.myElement.nativeElement;
    const mc = new Hammer(element);

    const element2 = this.myElement2.nativeElement;
    const mc2 = new Hammer(element2);

    // Aggiungi i riconoscitori per gestire eventi specifici
    mc.on('panleft panright', (ev: any) => {
      if (this.isProcessing) {
        // Se già in fase di elaborazione, ignora gli eventi successivi
        return;
      }

      this.isProcessing = true; // Blocca ulteriori azioni temporaneamente

      if (ev.type === 'panright') {
        if (this.slideSelected > 1) {
          this.slideSelected--;
        } else {
          this.slideSelected = 3;
        }
      } else if (ev.type === 'panleft') {
        if (this.slideSelected < 3) {
          this.slideSelected++;
        } else {
          this.slideSelected = 1;
        }
      }

      // Attendi un secondo prima di consentire ulteriori azioni
      setTimeout(() => {
        this.isProcessing = false; // Sblocca dopo il tempo di attesa
      }, 500); // Attesa di 1 secondo
    });

    mc2.on('panleft panright', (ev: any) => {
      if (this.isProcessing) {
        // Se già in fase di elaborazione, ignora gli eventi successivi
        return;
      }

      this.isProcessing = true; // Blocca ulteriori azioni temporaneamente

      if (ev.type === 'panright') {
        if (this.cardSelected > 1) {
          this.cardSelected--;
        } else {
          this.cardSelected = 3;
        }
      } else if (ev.type === 'panleft') {
        if (this.cardSelected < 3) {
          this.cardSelected++;
        } else {
          this.cardSelected = 1;
        }
      }

      // Attendi un secondo prima di consentire ulteriori azioni
      setTimeout(() => {
        this.isProcessing = false; // Sblocca dopo il tempo di attesa
      }, 500); // Attesa di 1 secondo
    });
  }

  changeSlide(id: number) {
    this.slideSelected = id;
  }

  changeSlideCard(id: number) {
    this.cardSelected = id;
  }

  openCourse(course: any) {
    this.router.navigateByUrl('/corsi' + course.url);
  }
}
